module.exports = __webpack_public_path__ + "static/media/ubereats.26bb9f82.png";